import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import Img from '../../../../Img' // task #67: canonical image component
import HighlightedText from '../../../../Utils/HighlightedText'
import Text from '../../../../Text'
import Spacer from '../../../../Spacer'

const cx = (...c) => c.filter(Boolean).join(' ')

function R295TextImage({ titleHl, titleIcon, subtitleHl, text, tags, badge, imageCs, reversed, tagsBeforeText, layoutTagsHorizontally, bottomPadding, largeImage }) {
  const renderTags = () => {
    return (
      <div
        className={cx(styles.tags, layoutTagsHorizontally && styles.tagsHorizontal)}
        style={{ order: tagsBeforeText ? 1 : 2 }}
      >
        <Spacer size={tagsBeforeText ? 16 : 32}/>
        { tags && tags.map(tag => <div className={styles.tag} key={tag.text}>
          {
            tag.icon && <div className={styles.tagIconWrapper}>
              {/* task #67: descriptor via <Img> */}
              <Img
                image={tag.icon.image}
                alt={tag.icon.alt}
                layout="fill"
                objectFit="contain"
              />
            </div>
          }
            <Text type="medium">{tag.text}</Text>
          </div>
        )}
      </div>
    )
  }

  const renderBadge = () => {
    return badge && <div className={styles.badge}>
      {
        badge.icon && <div className={styles.badgeIconWrapper}>
          {/* task #67: descriptor via <Img> */}
          <Img
            image={badge.icon.image}
            alt={badge.icon.alt}
            layout="fill"
            objectFit="contain"
          />
        </div>
      }
      <Text type="heading-8">{badge.text}</Text>
    </div>
  }


  return (
    <div className={cx(styles.wrapper, bottomPadding && styles.wrapperBottomPadding)}>
      <div className={cx(styles.contentWrapper, largeImage && styles.contentWrapperLarge)}>
        <div className={cx(styles.textWrapper, reversed && styles.textWrapperReversed)}>
          { titleHl && (
            <div className={styles.titleWrapper}>
              { titleIcon && <img className={styles.titleIcon} src={titleIcon?.src} style={{ aspectRatio: titleIcon?.aspectRatio || '1 / 1' }}/> }{/* task #67: styled img src + aspectRatio from descriptor */}
              <HighlightedText {...titleHl}/>
            </div>
          )}
          { subtitleHl && (<>
              <Spacer size={32}/>
              <HighlightedText {...subtitleHl}/>
            </>
          )}
          { text && <>
            <div className={styles.textBody} style={{ order: tagsBeforeText ? 2 : 1 }}>
              <Spacer size={16}/>
              <SimpleBlockContent blocks={text} noSpace/>
              { badge && renderBadge() }
            </div>
          </>
          }
          { !layoutTagsHorizontally && renderTags() }
        </div>
        <div className={cx(styles.images, reversed && styles.imagesReversed, largeImage && styles.imagesLarge)}>
          {
            imageCs && (
              <div className={cx(styles.imageWrapper, largeImage && styles.imageWrapperLarge)}>
                {/* task #67: descriptor via <Img> */}
                <Img
                  image={imageCs.image}
                  alt={imageCs.alt}
                  layout="fill"
                  objectFit="contain"
                  reserveSpace={false}
                />
              </div>
            )
          }
        </div>
      </div>
      { layoutTagsHorizontally && renderTags() }
    </div>
  )
}

export default R295TextImage
